import { createRouter, createWebHistory } from "vue-router";
import App from "./App.vue";
import store from "./store";

const routes = [
  {
    path: "/dashboard",
    name: "app",
    component: App,
    meta: { requiresAuth: true }, // Menandakan bahwa rute ini memerlukan autentikasi
    children: [
      {
        path: "",
        name: "dashboard",
        component: () => import("./pages/Dashboard.vue"),
      },
      {
        path: "/hp-users",
        name: "hp-users",
        component: () => import("./pages/master/UserHp.vue"),
      },
      {
        path: "/web-users",
        name: "web-users",
        component: () => import("./pages/master/UserWeb.vue"),
      },
      {
        path: "/master-mwp",
        name: "master-mwp",
        component: () => import("./pages/master/Mwp.vue"),
      },
      {
        path: "/master-userapp",
        name: "master-userapp",
        component: () => import("./pages/master/UserApp.vue"),
      },
      {
        path: "/master-distributor",
        name: "master-distributor",
        component: () => import("./pages/master/Distributor.vue"),
      },
      {
        path: "/master-salesman",
        name: "master-salesman",
        component: () => import("./pages/master/Salesman.vue"),
      },
      {
        path: "/master-target-kpi",
        name: "master-target-kpi",
        component: () => import("./pages/master/TargetKPI.vue"),
      },
      {
        path: "/master-outlet",
        name: "master-outlet",
        component: () => import("./pages/master/Outlet.vue"),
      },
      {
        path: "/master-pjp",
        name: "master-pjp",
        component: () => import("./pages/master/PJP.vue"),
      },
      {
        path: "/report-coaching",
        name: "report-coaching",
        component: () => import("./pages/report/Coaching.vue"),
      },
      {
        path: "/report-training",
        name: "report-training",
        component: () => import("./pages/report/Training.vue"),
      },
      {
        path: "/report-mwp",
        name: "report-mwp",
        component: () => import("./pages/report/Mwp.vue"),
      },
      {
        path: "/report-attendance",
        name: "report-attendance",
        component: () => import("./pages/report/Attendance.vue"),
      },
      {
        path: "/report-absence",
        name: "report-absence",
        component: () => import("./pages/report/Absence.vue"),
      },
      {
        path: "/example-page",
        name: "example-page",
        component: () => import("./pages/ExamplePage.vue"),
      },
    ],
  },
  {
    path: "/login",
    name: "login",
    component: () => import("./pages/Login.vue"),
  },
  {
    path: "/error",
    name: "error",
    component: () => import("./pages/Error.vue"),
  },
  {
    path: "/access",
    name: "access",
    component: () => import("./pages/Access.vue"),
  },
  {
    path: "/",
    redirect: "/dashboard",
  },
  {
    path: "/:catchAll(.*)",
    name: "NotFound",
    component: () => import("./pages/NotFound.vue"),
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach((to, from, next) => {
  const isAuthenticated = localStorage.getItem("authToken");
  const pageName = to.name;

  if (to.name === "login" && isAuthenticated) {
    next({ name: "dashboard" });
  } else {
    // Mengecek apakah rute saat ini memiliki children
    if (to.matched.some((route) => route.meta.requiresAuth)) {
      // Jika pengguna telah login, lanjutkan ke rute yang diminta
      if (isAuthenticated) {
        store.dispatch("auth/checkPermission", pageName);
        setTimeout(() => {
          if (localStorage.getItem("isPermission") == "false") {
            next({ name: "access" });
          } else {
            next();
          }
        }, 250);
      } else {
        // Jika pengguna belum login, redirect ke halaman login
        next({ name: "login" });
      }
    } else {
      // Jika rute tidak memiliki children, lanjutkan ke rute yang diminta
      next();
    }
  }
});
export default router;
